import { UPDATE_COMMUNICATION_LOGIN_SUCCESS, UPDATE_COMMUNICATION_LOGIN_FAILURE } from "redux/constants/MyM";

const initState = { data: [], error: false, errorData: "", isLoading: true }

export default (state = initState, action) => {
    switch (action.type) {
        case UPDATE_COMMUNICATION_LOGIN_SUCCESS:
            return {
                ...state, data: action.payload, isLoading: false
            }
        case UPDATE_COMMUNICATION_LOGIN_FAILURE:
            return {
                ...state, errorData: action.payload, error: true, isLoading: false
            }
        default:
            return {
                ...state
            }
    }
}